import styled from 'styled-components'

const SearchAndHeadingHolder = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export { SearchAndHeadingHolder }